module.exports = __webpack_public_path__ + "static/media/circle-ok.386cfcee.svg";